import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import './App.css';
import Router from './Router';
import { NotificationsActiveOutlined, PeopleOutlined, SettingsOutlined } from '@mui/icons-material';

const notificationIcon = <NotificationsActiveOutlined className="text-white" />;
const usersIcon = <PeopleOutlined style={{ color: '#ffbe5f' }} />;
const adminIcon = <SettingsOutlined style={{ color: '#ffbe5f' }} />;

export const globalMenuItems = [
  // Main menu items
  { name: 'Dashboard', link: '/dashboard' },
  { name: 'Historical prices', link: '/historical-prices' },
  { name: 'Future orders', link: '/future-order', isSalesCommitment: 2 },
  { name: 'Sales commitments', link: '/sales-commitments', isSalesCommitment: 1 },
  { name: 'Inventory', link: '/Inventory' },
  { name: 'Financial positions', link: '/financial-positions' },
  { name: 'Strategy', link: '/strategy' },
  { name: 'Upload Files', link: '/upload-files' },
  { name: 'Notifications', link: '/notifications', icon: notificationIcon },

  // Admin section
  { name: 'Users', link: '/admin/users', isAdminOnly: true, icon: usersIcon },
  { name: 'Admin Data', link: '/admin-change-data', isAdminOnly: true, icon: adminIcon },

  // { name: 'Quotes', link: '/client-order' },
  // { name: 'Settings', link: '/products-dashboard' },
  // { name: 'Builder', link: '/policy' },
  // { name: 'Policy', link: '/policy/material' },
  // { name: 'Account', link: 'unauthorized' },
  // { name: 'Performance', link: '/route-optimization' },
  // { name: 'Routes optimization', link: '/opportunity', isAdminOnly: true },
];

document.addEventListener('DOMContentLoaded', () => {
  const ogUrlMeta = document.querySelector('meta[property="og:url"]');
  if (ogUrlMeta) {
    const path = window.location.pathname?.match(/^\/([^/]+)/)?.[0] || '';
    console.log('url', window.location.origin + path);
    ogUrlMeta.setAttribute('content', window.location.origin + path);
  }
});

const queryClient = new QueryClient();

function App() {
  return (
    <div className="App w-screen h-screen overflow-x-hidden overflow-y-hidden bg-light-blue 	">
      <QueryClientProvider client={queryClient}>
        <Router />
        <ReactQueryDevtools />
      </QueryClientProvider>
    </div>
  );
}

export default App;
